<template>
  <div class="xfmx-box-container" v-if="show" @click="show = false">
  	<div class="xfmx-box">
  		<div class="xfmx-box-top">
  			<span>{{$t('all.xiaofeimingxi')}}</span>
  			<img src="../../assets/image/tanchuang_x_b@2x.png" alt="关闭" @click="handleClose" />
  		</div>
  		<div class="xfmx-list" ref="listContainer" @scroll="handleScroll">
  			<div class="xfmx-list-item" v-for="(item,index) in list" :key="index">
  				<div class="xfmx-list-item-left">
  					<span class="xfmx-list-item-left-span">{{item.billDesc}}</span>
  					<span class="xfmx-list-item-left-span1">{{item.createTime}}</span>
  				</div>
				<span class="xfmx-list-item-span">{{item.amount}}</span>
  			</div>
  		</div>
  	</div>
  </div>
</template>

<script>
import kong from "../kong/kong.vue";
import { getBalanceBillList } from "@/api/user";
export default {
  components: {
    kong
  },
  data() {
    return {
	  show:false,
	  queryParams:{
	  	page:1,
	  	size:20,
	  },
	  list:[],
	  hasMore: true,
	  isLoading: false,
	  isKong:false,
    };
  },
  mounted() {
	this.getBalanceBillList()
  },
  methods: {
	// 获取消费明细
	async getBalanceBillList() {
	  // 3. 如果正在加载或没有更多数据，则直接返回
	  if (this.isLoading || !this.hasMore) {
		return;
	  }
	
	  try {
		// 4. 发起请求前，将加载状态设为 true
		this.isLoading = true;
	
		const response = await getBalanceBillList(this.queryParams);
		const newList = response.rows || [];
	
		if (this.queryParams.page === 1) {
		  this.list = newList;
		} else {
		  this.list = [...this.list, ...newList];
		}
	
		const totalPages = Math.ceil((response.total || 0) / this.queryParams.size);
		this.hasMore = this.queryParams.page < totalPages;
	    if(response.total == 0){
			this.isKong = true
		}else{
			this.isKong = false
		}
	  } catch (error) {
		console.error("获取直播列表失败:", error);
	  } finally {
		// 5. 请求结束（无论成功或失败），将加载状态恢复为 false
		this.isLoading = false;
	  }
	},
	
	// 滚动事件处理函数
	handleScroll() {
	  // 同样增加 isLoading 判断，防止在请求期间触发
	  if (this.isLoading || !this.hasMore) {
		return;
	  }
	
	  const container = this.$refs.listContainer;
	  // 判断滚动条是否到达底部（或接近底部）
	  const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50; // 50px的缓冲距离
	
	  if (isAtBottom) {
		console.log("滚动到底部，触发加载更多");
		this.queryParams.page++;
		this.getBalanceBillList();
	  }
	},
	//显示弹框
	showXfmx(){
		this.show = true
	},
	//关闭弹框
	handleClose(){
		this.show = false
	}

  }
};
</script>
<style scoped lang="scss">
	@import "./xiaofeimingxi.css";
</style>


// WEBPACK FOOTER //
// xiaofeimingxi.vue?2f0022be